import { APIError, get } from '@user/store/services/crud'
import { ServiceConfig } from '@user/store/services/config'

import { SoldServiceAppDataFetchResult as Result } from '../typings'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.opportunity.opportunity}`

export async function getCustomFieldAppData(
  opportunityId: number,
): Promise<Result> {
  const result: Result = {
    appData: [],
    customFields: {},
  }

  const response = await get(
    `${baseUrl}/${opportunityId}${ServiceConfig.opportunity.soldServiceAppData}`,
  )

  if (response.ok) {
    result.appData = await response.json()

    result.appData.map((data) => {
      const { id, type } = data

      switch (type) {
        case 'Boolean':
          result.customFields[id] = false
          break

        case 'Date':
          result.customFields[id] = null
          break

        default:
          result.customFields[id] = ''
          break
      }
    })
  } else {
    const error = (await response.json()) as APIError
    throw error.Message
  }

  return result
}
